import Clerk from "@clerk/clerk-js";

if (!process.env.REACT_APP_CLERK_PUBLISHABLE_KEY) {
    throw new Error("Missing Publishable Key")
}
export const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY

export const clerkJS = new Clerk(clerkPubKey);